import React, { useState } from 'react'

import './styles.scss'
import TranslationsSection from './TranslationsSection'
import LabelsSection from './LabelsSection'
import { tabTypes } from './utils'
import { lang } from 'utils/helpers'

const TranslationsView = () => {
  const [selectedTab, setSelectedTab] = useState(tabTypes[0])

  return (
    <div className='translations-view'>
      <div className='translations-view__tabs-container'>
        {tabTypes.map(tabType => (
          <button
            key={tabType}
            className={`
              translations-view__tab
              ${selectedTab === tabType ? 'translations-view__tab--active' : ''}
            `}
            onClick={() => setSelectedTab(tabType)}
          >
            {lang(`dashboard_${tabType}`)}
          </button>
        ))}
      </div>
      <div className='translations-view__content'>
        {selectedTab === 'translations' ? <TranslationsSection /> : null}
        {selectedTab === 'labels' ? <LabelsSection /> : null}
      </div>
    </div>
  )
}

export default TranslationsView
